import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NavbarComponent } from '../navbar/navbar.component';
import { GmailBannerComponent } from '../gmail-banner/gmail-banner.component';

@Component({
  selector: 'app-main-layout',
  standalone: true,
  imports: [CommonModule, RouterModule, NavbarComponent, GmailBannerComponent],
  templateUrl: './main-layout.component.html',
})
export class MainLayoutComponent {}
